
import { Component, Vue } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import Message from '../../components/Platform/Message.vue'
import Record from '../../components/Platform/Record.vue'
import { formatDate } from '../../utils/publish'


@Component({
  name: 'serve',
  components: { Message, Record }

})
export default class extends Vue {
  list: any = []

  tableData: any = []
  time = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30), new Date()]
  activeName: string = 'first'
  tableHeight: number = window.innerHeight - 200
  messagePop: boolean = false
  form: any = {
    name: 'text'
  }
  is_show: number = 1
  recordPop: boolean = false
  messageTemplate: any = []
  messageTemplateId: string = ''
  userList: any = []
  userId: string = ''
  messageTitle: string = ''
  page: number = 1
  size: number = 10
  total_count: number = 0
  frequency: any = [
    { id: '1', name: '周一' },
    { id: '2', name: '周二' },
    { id: '3', name: '周三' },
    { id: '4', name: '周四' },
    { id: '5', name: '周五' },
    { id: '6', name: '周六' },
    { id: '7', name: '周日' },
  ]
  messagePopTitle: string = ''
  messageItemVal: any = []
  is_message_enabled: Number = 0


  mounted() {
    this.getHeight()
    this.messageNoticeEnable()
    this.getMessageTemplate()   // 短信模板
  }

  changeStatus() {
    let text = ''
    if (this.is_message_enabled === 0) {
      text = '启用'
    } else {
      text = '停用'
    }
    this.$confirm(`是否变更24小时短信提醒状态为${text}`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async ()=> {
      let data = {
        is_enabled: this.is_message_enabled === 0 ? 1 : 0
      }
      this.enabledMessage(data)
    }).catch(() => {})
  }

  async messageNoticeEnable() {
    const res: any = await CourseModule.messageNoticeEnable()
    if(res.code === 200) {
      this.is_message_enabled = res.data.is_enabled
    }
  }

  async enabledMessage(data) {
    const res: any = await CourseModule.messageEnable(data)
    if(res.code === 200) {
      this.messageNoticeEnable()
      this.$message({
        type: 'success',
        message: '修改成功!'
      })
    } else {
      this.$message({
        type: 'error',
        message: '修改失败!'
      })
    }
  }

  changeHandle(val) {
    let text = ''
    if (val.is_enabled === 0) {
      text = '已启用'
    } else {
      text = '未启用'
    }
    this.$confirm(`是否变更状态为${text}`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async ()=> {
      let data = {
        id: val.id,
        is_enabled: val.is_enabled === 0 ? 1 : 0
      }
      this.enabledStatus(data)
    }).catch(() => {})
  }

  async enabledStatus(val) {
    const res: any = await CourseModule.messageTaskPut(val)
    if(res.code === 200) {
      this.$message({
        type: 'success',
        message: '修改成功!'
      })
       this.getMessageTask()
    } else {
      this.$message({
        type: 'error',
        message: '修改失败!'
      })
    }
  }

  getRecord() {
    this.recordPop = true
  }
  getDate(time, type) {
    return formatDate(time, type)
  }
  //  获取短信模板
  async getMessageTemplate() {
    const res: any = await CourseModule.messageTemplate()
    if (res.code === 200) {
      this.messageTemplate = res.data
      this.getAllTeacher()  // 获取创建人
    }
  }
  //  获取创建人
  async getAllTeacher() {
     const res: any = await CourseModule.getAllTeacher({ is_all: 1 })
     if(res.code === 200) {
       this.userList = res.data.list
       this.getMessageTask()
     }
  }
  // 筛选短信标题
  changeMessageTitle() {
    this.getMessageTask()
  }
  // 创建人筛选
  userChange() {
    this.getMessageTask()
  }
  // 短信内容搜索
  changeMessageTemplate() {
    this.getMessageTask()
  }
  // 获取短信列表
  async getMessageTask() {
    const res: any = await CourseModule.getMessageTask({ template_id: this.messageTemplateId, id: '', employee_id: this.userId, name: this.messageTitle, page: this.page, size: this.size })
    if (res.code === 200) {
      this.tableData = res.data.list
      this.total_count = res.data.total
    }
  }
  handleCurrentChange(val) {
    this.page = val
    this.getMessageTask()
  }
  getFrequency(val) {
    if (!val) {
      return false
    }
    let arr:any = val.split(',')
    let str: any = []
    for(var i = 0; i < arr.length; i++) {
      for(var j = 0; j < this.frequency.length; j++) {
        if(arr[i] === this.frequency[j].id) {
          str.push(this.frequency[j].name)
        }
      }
    }
    return str.join(',')
  }

  closeMessage(val) {
    if(val.type) {
      this.getMessageTask()
    }
    this.messagePop = false
  }
  closeRecord(val) {
    this.recordPop = false
  }
  addMessage(val) {
    this.messagePopTitle = 'add'
    this.messagePop = true
  }
  editMessage(val) {
    this.getMessageRow(val.id)
  }
  getExecuteTime(val) {
    if(!val) {
      return false
    }
    let arr = val.split(',')
    let newArr = []
    for(var i = 0; i < arr.length; i++) {
      if(i % 2) {
        newArr.push(arr[i])
      }
    }
    return newArr.join(',')
  }

  //获取单行数据
  async getMessageRow(id) {
    const res: any = await CourseModule.getMessageTaskDetails({ id: id })
    this.messagePopTitle = 'edit'
    this.messagePop = true
    this.messageItemVal = res.data.list[0]
  }

  async deleteMessageList(val) {
    const res: any = await CourseModule.deleteMessageTask({ id: val.id })
    if(res.code === 200) {
      this.$message({
        type: 'success',
        message: '删除成功!'
      })
      this.getMessageTask()
    } else {
      this.$message.error('删除失败')
    }
  }
  
  // 删除短信列表
  async deleteMessage(val) {
    this.$confirm('是否确认删除?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.deleteMessageList(val)
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '取消删除'
      })
    })
  }

  getHeight() {
    window.onresize = () => {
      this.tableHeight = window.innerHeight - 200
    }
  }
}
